// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3SvK4","choiceBoxes":"toolbarselects_choiceBoxes__35Gve","simpleField":"toolbarselects_simpleField__32IHg"};